import { render } from "./PlatformSummaryReport.vue?vue&type=template&id=bb0be4ba"
import script from "./PlatformSummaryReport.vue?vue&type=script&lang=js"
export * from "./PlatformSummaryReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__